import ko from './ko'
import en from './en'
import ja from './ja'

export default { ko, en, ja }
